import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Button } from "@charisol-spark/ui";
import mascotSad from "./assets/mascot-sad2.png?format=webp&w=512";

/**
 * Marketing 404.
 *
 * Separate from the app's because the way out differs: someone who mistypes a
 * public URL wants the home page, not a dashboard they may not have an account
 * for. "/" is inside this bundle, so it stays a client-side <Link>.
 */
export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <div className="mx-auto mb-2 flex h-48 w-48 items-center justify-center overflow-hidden rounded-full ring-4 ring-muted/50 drop-shadow-xl sm:h-56 sm:w-56">
        <img
          src={mascotSad}
          alt=""
          aria-hidden="true"
          className="h-full w-full object-contain"
        />
      </div>
      <h1 className="text-6xl font-bold gradient-text">404</h1>
      <p className="text-xl text-muted-foreground">Page not found</p>
      <p className="text-sm text-muted-foreground max-w-md">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <Link to="/">
        <Button variant="outline" pill>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to home
        </Button>
      </Link>
    </div>
  );
}
